var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertCancelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_350_11",
    "data-name": "Component 350 \\u2013 11",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cancel_black_24dp"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14593",
    "data-name": "Path 14593",
    d: "M0,0H24V24H0Z",
    fill: "none",
    opacity: 0.87
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14594",
    "data-name": "Path 14594",
    d: "M12,2A10,10,0,1,0,22,12,9.991,9.991,0,0,0,12,2Zm4.3,14.3a1,1,0,0,1-1.41,0L12,13.41,9.11,16.3A1,1,0,1,1,7.7,14.89L10.59,12,7.7,9.11A1,1,0,0,1,9.11,7.7L12,10.59,14.89,7.7A1,1,0,0,1,16.3,9.11L13.41,12l2.89,2.89a1.014,1.014,0,0,1,0,1.41Z",
    fill: "#000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertCancelIcon);
export default __webpack_public_path__ + "static/media/alert-cancel-icon.a6bc7a5ed8ec5ff314cf6e16a9ac5a87.svg";
export { ForwardRef as ReactComponent };